<form [formGroup]="filterForm">
  <div class="flex flex-col">
    <div class="flex justify-end item-center content-stretch">
      <div *ngIf="hasFiltersSet()" class="pt-4 pr-3">
        <button
          mat-button
          color="secondary"
          (click)="resetFilters()"
          matTooltip="Reset filters back to their default values"
        >
          <mat-icon>clear</mat-icon>
          Reset Filters
        </button>
      </div>
      <mat-form-field
        [floatLabel]="'never'"
        appearance="outline"
        class="w-1/4 content-list_search-box"
      >
        <input
          matInput
          [formControlName]="FORM_FIELDS.CONTENT_SEARCH_FILTER"
          placeholder="Search... "
        />
        <mat-icon *ngIf="getSearchValue() === ''" matSuffix class="ml-2"
          >search</mat-icon
        >
        <button
          mat-button
          *ngIf="getSearchValue() !== ''"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="setSearchValue('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="w-full min-w-full font-sans mat-elevation-z0 content__table">
      <div
        class="relative w-full min-w-full font-sans mat-elevation-z0 content__table"
      >
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="w-full min-w-full font-sans table-fixed content__table"
          matSortActive="lastModifiedDateTime"
          matSortDirection="desc"
        >
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="display-unset"
              >
                <mat-label>Status</mat-label>
                <mat-select
                  matNativeControl
                  multiple
                  [formControlName]="FORM_FIELDS.STATUS_FILTER"
                >
                  <mat-select-trigger>
                    {{ filterValues.status ? filterValues.status[0] : "" }}
                    <span *ngIf="filterValues.status?.length > 1">
                      (+{{ filterValues.status.length - 1 }}
                      {{
                        filterValues.status.length === 2 ? "other" : "others"
                      }})
                    </span>
                  </mat-select-trigger>
                  <mat-option
                    *ngFor="let status of statusList"
                    [value]="status"
                    >{{ status }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let content" class="py-3">
              <a
                *ngIf="!(isEnabledForContentType$(content.contentType) | async)"
                color="primary"
                [queryParams]="{
                  page: pageTracker,
                  search: getSearchValue() === '' ? null : getSearchValue()
                }"
                [href]="'/#/content/' + content.contentId"
              >
                <i class="icon icon-bullhorn" *ngIf="content.isSponsored"></i>
                <i
                  class="icon icon-picture-o"
                  *ngIf="isGallery(content.contentType)"
                ></i>
                {{ content.title }}
              </a>
              <a
                *ngIf="isEnabledForContentType$(content.contentType) | async"
                color="primary"
                [queryParams]="{
                  page: pageTracker,
                  search: getSearchValue() === '' ? null : getSearchValue()
                }"
                [routerLink]="
                  getRouteForContentType(
                    content.contentType,
                    content.contentId,
                    content.status
                  )
                "
              >
                <i class="icon icon-bullhorn" *ngIf="content.isSponsored"></i>
                <i
                  class="icon icon-picture-o"
                  *ngIf="content.contentType === contentTypeEnum.Gallery"
                ></i>
                {{ content.title }}
              </a>
              <br />
              <span
                [ngClass]="{
                  'alert-status': true,
                  'alert-default': content.status === contentStatus.PUBLISHED,
                  'alert-writing': content.status === contentStatus.WRITING,
                  'alert-editing': content.status === contentStatus.EDITING,
                  'alert-editing-journalist':
                    content.status === contentStatus.JOURNALIST_EDITING,
                  'alert-waiting':
                    content.status === contentStatus.WAITING_FOR_EDITING,
                  'alert-waiting-journalist':
                    content.status ===
                    contentStatus.WAITING_FOR_JOURNALIST_EDITING,
                  'alert-waiting-subediting':
                    content.status === contentStatus.WAITING_FOR_SUBEDITING,
                  'alert-subediting':
                    content.status === contentStatus.SUBEDITING,
                  'alert-approved-subeditor':
                    content.status === contentStatus.SUBEDITOR_APPROVED,
                  'alert-live-published':
                    content.status === contentStatus.PUBLISHED,
                  'alert-spiked': content.isSpiked
                }"
              >
                <span *ngIf="!content.isSpiked">{{
                  content.status | contentStatusDescription
                }}</span>
                <span *ngIf="content.isSpiked">Spiked</span>
              </span>

              <span *ngIf="isPublished(content.status)" class="entry-meta">
                <i class="icon icon-clock-o"></i>
                {{ content.publishedDate | formatdate }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="contentType">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="display-unset"
              >
                <mat-label>Content type</mat-label>
                <mat-select
                  matNativeControl
                  multiple
                  [formControlName]="FORM_FIELDS.CONTENT_TYPE_FILTER"
                >
                  <mat-select-trigger>
                    {{
                      (filterValues.contentType
                        ? filterValues.contentType[0]
                        : ""
                      ) | camelCaseSplit
                    }}
                    <span *ngIf="filterValues.contentType?.length > 1">
                      (+{{ filterValues.contentType.length - 1 }}
                      {{
                        filterValues.contentType.length === 2
                          ? "other"
                          : "others"
                      }})
                    </span>
                  </mat-select-trigger>
                  <mat-option
                    *ngFor="let contentType of contentTypeList"
                    [value]="contentType"
                  >
                    {{ contentType | camelCaseSplit }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let content" class="py-3">
              {{ content.contentType | camelCaseSplit }}
            </td>
          </ng-container>

          <ng-container matColumnDef="topics">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="display-unset"
              >
                <mat-label>Topics</mat-label>
                <mat-select
                  matNativeControl
                  [formControl]="selectedTopicIds"
                  multiple
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="searchTopicText"
                      placeholderLabel="Search topics..."
                    >
                    </ngx-mat-select-search>
                  </mat-option>

                  <mat-option
                    #matOption
                    *ngFor="let topics of topicResults"
                    [value]="topics.id"
                    (click)="
                      updateTopicList(matOption.value, matOption.selected)
                    "
                  >
                    {{ topics.displayName | camelCaseSplit }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let content" class="py-3">
              <p *ngFor="let topic of content.topics">
                {{ topic.displayName }}
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="website">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="display-unset"
              >
                <mat-label>Edition</mat-label>
                <mat-select
                  matNativeControl
                  multiple
                  [formControlName]="FORM_FIELDS.WEBSITES_FILTER"
                >
                  <mat-select-trigger>
                    {{ filterValues.websites ? filterValues.websites[0] : "" }}
                    <span *ngIf="filterValues.websites?.length > 1">
                      (+{{ filterValues.websites.length - 1 }}
                      {{
                        filterValues.websites.length === 2 ? "other" : "others"
                      }})
                    </span>
                  </mat-select-trigger>
                  <mat-option
                    *ngFor="let website of websiteList"
                    [value]="website"
                    >{{ website }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let content" class="py-3">
              <p *ngFor="let targetCode of content.deliveryTargetCodes">
                <a
                  [href]="
                    getUrl(
                      content.status,
                      content.versionId,
                      targetCode,
                      content.urlsByDeliveryTargetCodes &&
                        content.urlsByDeliveryTargetCodes[targetCode]
                    )
                  "
                  target="_blank"
                >
                  {{ getTargetCodeFriendlyName(targetCode) }}
                </a>
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="author">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="display-unset"
              >
                <mat-label>Authors</mat-label>
                <mat-select
                  matNativeControl
                  multiple
                  [formControl]="selectedAuthorIds"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="searchAuthorText"
                      placeholderLabel="Search authors..."
                      noEntriesFoundLabel="No authors found"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    #matOption
                    *ngFor="let author of authorResults"
                    [value]="author.id"
                    (click)="
                      updateAuthorList(matOption.value, matOption.selected)
                    "
                  >
                    {{ author.name | camelCaseSplit }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let content" class="py-3">
              <p *ngFor="let author of content.authors">{{ author.name }}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="lastModifiedDateTime">
            <th mat-header-cell *matHeaderCellDef>
              <mat-form-field
                [floatLabel]="'never'"
                appearance="outline"
                class="display-unset"
              >
                <mat-label>Modified</mat-label>
                <mat-select
                  matNativeControl
                  [formControlName]="FORM_FIELDS.MODIFIED_FILTER"
                  disableOptionCentering
                >
                  <mat-option
                    *ngFor="let time of MODIFIED_TIME_SELECTION_LIST"
                    [value]="time.id"
                    >{{ time.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </th>
            <td mat-cell *matCellDef="let content" class="py-3">
              <mat-icon inline class="w-5 px-1">access_time</mat-icon>
              <span>{{ content.lastUpdatedOn | formatdate }}</span>
              <br />
              <span>
                <p class="w-9/12 overflow-hidden truncate">
                  <i class="icon icon-user"></i>
                  {{ content.lastUpdatedByUser }}
                </p>
              </span>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="DISPLAYED_COLUMNS"
            class="px-4 py-3 border-t bg-project-600 border-t-project-700"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: DISPLAYED_COLUMNS"></tr>
        </table>

        <app-processing-boundary
          *ngIf="isProcessing || !dataSource?.filteredData.length"
          class="flex h-full"
          [ngClass]="{
            'min-h-[20vh]': !dataSource?.filteredData.length
          }"
          [isProcessing]="isProcessing"
          [showEmptyResultMsg]="!dataSource?.filteredData.length"
          [processingMsg]="'Loading content...'"
          [cssClasses]="[
            'absolute',
            'top-[4.3rem]',
            'w-full',
            'h-full',
            'backdrop-contrast-50'
          ]"
        >
        </app-processing-boundary>

        <!-- TODO ISSUE: Replace this with section table footer -->
        <div
          class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
          *ngIf="dataSource?.filteredData.length"
        >
          <div>
            <button
              class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100"
              (click)="loadContentData()"
              title="Refresh"
            >
              <i class="icon icon-refresh"></i>
            </button>
            <mat-form-field
              [floatLabel]="'never'"
              class="w-16 text-sm leading-[0.99rem] content-lists__page-select inline-block"
              appearance="outline"
            >
              <mat-select [formControl]="pageSizeFilter">
                <mat-option *ngFor="let page of pagingOptions" [value]="page">
                  {{ page }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span class="pl-3">per page</span>
          </div>
          <div>
            <button
              class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
              [disabled]="!hasPreviousPage()"
              (click)="loadPreviousPage()"
            >
              Previous
            </button>
            <button
              *ngFor="let num of pageNumbers"
              class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
              (click)="selectPage(num)"
              [disabled]="isActivePage(num)"
              [ngClass]="{
                'content__page-button--current': isActivePage(num)
              }"
            >
              {{ num }}
            </button>
            <button
              class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
              (click)="loadNextPage()"
              [disabled]="!hasNextPage()"
            >
              Next
            </button>
          </div>
        </div>
      </div>
      <mat-paginator
        #paginator
        [pageIndex]="pageTracker"
        [pageSize]="pageSize"
        [pageSizeOptions]="pagingOptions"
        class="invisible"
      ></mat-paginator>
    </div>
  </div>
</form>
